import {ApiService} from '../ApiService'
import {AuthDto, LoginByUsernamePasswordBody} from './type'

class AuthServiceProvider extends ApiService {
  async login(token: string): Promise<AuthDto> {
    const response = await this.get<AuthDto>(`/authorization-tokens/sso/${token}`, undefined)
    const attributes = response.data.attributes as any

    const transformedResponse = {
      ...response,
      data: {
        ...response.data,
        attributes: {
          activationId: attributes['activation-id'],
          expiresAt: attributes['expires-at'],
          user_id: attributes['user-id'],
          user_role: attributes['user-role'],
        },
      },
    }

    return transformedResponse
  }

  async login_xpertKnowledge(jwt: string): Promise<AuthDto> {
    const response = await this.post<AuthDto>(`/xpert-knowledge/login`, undefined, {
      headers: {
        Authorization: `xpertToken ${jwt}`,
      },
    })
    const attributes = response.data.attributes as any

    const transformedResponse = {
      ...response,
      data: {
        ...response.data,
        attributes: {
          activationId: attributes['activation-id'],
          expiresAt: attributes['expires-at'],
          user_id: attributes['user-id'],
          user_role: attributes['user-role'],
        },
      },
    }

    return transformedResponse
  }

  async login_username_password(body: LoginByUsernamePasswordBody): Promise<AuthDto> {
    const response = await this.post<AuthDto>(`/authorization-tokens/login`, body)
    const attributes = response.data.attributes as any

    const transformedResponse = {
      ...response,
      data: {
        ...response.data,
        attributes: {
          activationId: attributes['activation-id'],
          expiresAt: attributes['expires-at'],
          user_id: attributes['user-id'],
          user_role: attributes['user-role'],
        },
      },
    }

    return transformedResponse
  }
}

export const AuthService = new AuthServiceProvider()
